import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../types/types';
import { IFieldsColumnsHOCProps } from './types';
import { getCardFields } from '../../selectors/getCardFields';
import { onClick } from './events/onClick';
import { IFieldsColumnsEvents, IFieldsColumnsFields } from '../../components/FieldsColumns/types';
import { FieldsColumns } from '../../components/FieldsColumns/FieldsColumns';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IFieldsColumnsHOCProps
): IFieldsColumnsFields => {
    return {
        cardFields: getCardFields(state, boardId)
    }
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IFieldsColumnsHOCProps
): IFieldsColumnsEvents => {
    return {
        onClick: (field) => dispatch(onClick(boardId, field))
    }
};

export const FieldsColumnsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(FieldsColumns);

FieldsColumnsHOC.displayName = 'FieldsColumnsHOC';
